import type { IWsVisibility } from "../types";

export const browserVisibility: IWsVisibility = {
  isHidden: () => document.hidden,
  onChange: (cb) => {
    const handler = () => cb();
    document.addEventListener("visibilitychange", handler);
    return () => document.removeEventListener("visibilitychange", handler);
  },
};
